import { createService } from 'reservice'
import {
  FETCH_VAPID,
  FETCH_CHECK_SUBSCRIBE,
  FETCH_NOTIFICATION_COUNT,
  FETCH_NOTIFICATION_BY_ID,
  FETCH_NOTIFICATIONS,
  CREATE_SUBSCRIBE,
  UPDATE_READ_NOTIFICATION,
  UPDATE_READ_ALL_NOTIFICATIONS,
  DELETE_SUBSCRIBE
} from '../actionTypes'

// scm
export const fetchVapid = createService(FETCH_VAPID)
export const fetchCheckSubscribe = createService(FETCH_CHECK_SUBSCRIBE)
export const fetchNotificationCount = createService(FETCH_NOTIFICATION_COUNT)
export const fetchNotificationById = createService(FETCH_NOTIFICATION_BY_ID)
export const fetchNotifications = createService(FETCH_NOTIFICATIONS)
export const createSubscribe = createService(CREATE_SUBSCRIBE)
export const updateReadNotification = createService(UPDATE_READ_NOTIFICATION)
export const updateReadAllNotifications = createService(UPDATE_READ_ALL_NOTIFICATIONS)
export const deleteSubscribe = createService(DELETE_SUBSCRIBE)
